import React, { createContext, useContext, useState } from 'react';
import { Template } from '../dtos';

type State = {
    templates: Template[];
    setTemplates: React.Dispatch<React.SetStateAction<Template[]>>;
};

type Props = {
    children: React.ReactNode;
};

const TemplateContext = createContext<State>({} as State);

const TemplateProvider: React.FC<Props> = ({ children }) => {
    const [templates, setTemplates] = useState<Template[]>([]);

    return (
        <TemplateContext.Provider
            value={{
                templates,
                setTemplates,
            }}
        >
            {children}
        </TemplateContext.Provider>
    );
};

const useTemplate = (): State => {
    const context = useContext(TemplateContext);

    return context;
}

export { TemplateProvider, useTemplate };